module.exports = __webpack_public_path__ + "img/title1.037206ae.png";